import LayoutActividad from "../../../components/LayoutActividad";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Prestigio1 from "../../../images/modulo14/prestigio1.png";
import Prestigio2 from "../../../images/modulo14/prestigio2.png";

const Actividad5 = () => {
  const infoUnidad = modulo14.content[2];
  const infoAct = modulo14.content[2].activities[5];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[2].name}: ${modulo14.content[2].activities[6].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[6].path}`,
    titlePrev: `${modulo14.content[2].name}: ${modulo14.content[2].activities[4].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[4].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-4 mt-5 rounded">
        <div className="row align-items-center">
          <div className="col-md-9 col-12 p-md-3 p-0">
            <h4 className="mb-4">
              <strong>¿Qué es eso del prestigio?</strong>
            </h4>
            <p className="mt-1">
              Todas las lenguas y variedades de una lengua son igual de
              valiosas, pero algunas tienen más prestigio que otras. Ese
              prestigio no tiene nada que ver con la lengua en sí misma, sino
              con {" "}
              <strong>la gente que la habla</strong>. Por ejemplo, en el mundo
              actual, el inglés es una lengua muy prestigiosa porque se asocia
              con el desarrollo y el bienestar económico.
            </p>
          </div>
          <div className="col-md-3 col-12">
            <img
              src={Prestigio2}
              className="bg-white img-fluid rounded w-100"
              alt="Prestigio"
            />
          </div>
          <div className="col-md-3 col-12">
            <img
              src={Prestigio1}
              className="bg-white img-fluid rounded w-100"
              alt="Prestigio"
            />
          </div>
          <div className="col-md-9 col-12 p-md-5 p-0">
            <p>
              En la <strong>época incaica</strong>, la lengua más prestigiosa
              era el{" "}
              <strong>quechua</strong>, pues era la lengua de los incas, quienes
              tenían el poder.
            </p>
            <p>
              Cuando llegaron los <strong>españoles</strong>, la lengua más
              prestigiosa pasó a ser el <strong>castellano</strong>, pues era la
              que hablaban los conquistadores.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que lean en silencio el texto titulado ¿Qué es eso del
            prestigio?. Luego, léala usted nuevamente en voz alta para toda la
            clase.
          </li>
          <li>
            Resalte la idea principal del texto: el prestigio de las lenguas no
            tiene que ver con la lengua en si misma (con su vocabulario,
            gramática, etc.), sino con la gente que la habla. Ello, como se
            muestra en el texto, varía en el tiempo. Así, con los incas, la
            lengua prestigiosa fue el quechua y luego, con los españoles, pasó a
            ser el castellano. Ello está asociado a los grupos que poseen poder
            político o económico.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
